import { render, staticRenderFns } from "./DateWidgetPanel.vue?vue&type=template&id=67507723&scoped=true"
import script from "./DateWidgetPanel.vue?vue&type=script&lang=js"
export * from "./DateWidgetPanel.vue?vue&type=script&lang=js"
import style0 from "./DateWidgetPanel.vue?vue&type=style&index=0&id=67507723&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67507723",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67507723')) {
      api.createRecord('67507723', component.options)
    } else {
      api.reload('67507723', component.options)
    }
    module.hot.accept("./DateWidgetPanel.vue?vue&type=template&id=67507723&scoped=true", function () {
      api.rerender('67507723', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/editor/settingPanel/DateWidgetPanel.vue"
export default component.exports